<loading v-model:active="loading" :can-cancel="false" :is-full-page="true" loader="bars" />
<div class="grid overflow-x-scroll overflow-y-scroll p-0 m-0">
    <div class="col-12">

        <div v-if="page" class="pb-6">
            <span class="font-bold text-lg">{{page.title.rendered}}</span>
            <hr>
            <div id="my-konten" v-html="page.content.rendered"></div>
        </div>
        <div v-else class="pb-6">
            <span class="font-bold text-lg">{{p.title.rendered}}</span>
            <hr>
            <div id="my-konten" v-html="p.content.rendered"></div>
        </div>
        <!--
        <div v-else class="align-items-center justify-content-center text-center">
            <span class=" text-2xl font-bold">{{message}}</span>
        </div>
        -->
    </div>
</div>